import { Icon } from '@chakra-ui/react';

export const DoneIcon = () => (
  <Icon viewBox="120 80 230 350" color="black" boxSize={6} width={'15px'}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
      <path d="m9 11 3 3L22 4"></path>
    </svg>
  </Icon>
);
